import { jsx as _jsx } from "react/jsx-runtime";
import { lazy, Suspense } from 'react';
const LazyVerificationFlow = lazy(() => import('./VerificationFlow').then(module => ({
    default: module.VerificationFlow,
})));
/**
 * Our shared user verification system
 *
 * @constant
 */
export const VerificationFlow = () => (_jsx(Suspense, Object.assign({ fallback: null }, { children: _jsx(LazyVerificationFlow, {}) })));
